import React from 'react';
import { connect } from 'react-redux';

import BasePage from 'components/utils/BasePage';

import { DL_EMAIL_CONFIRM_REDIRECT } from '../../../constants/UrlConstants';
import BaseLayoutPromo from '../common/BaseLayoutPromo';
import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';

const EmailConfirm = (props) => {
    return (
        <BaseLayoutPromo>
            <PromoInfoPage
                animatedIconSuccess={props.confirm}
                animatedIconFail={!props.confirm}
                headerText={props.confirm ? props.emailConfirmSuccessText : props.emailNotConfirmText}
                primaryButtonType="link"
                primaryButtonCaption={props.continueButton}
                primaryButtonLink={DL_EMAIL_CONFIRM_REDIRECT}
            />
        </BaseLayoutPromo>
    );
};
const mapStateToProps = (state) => {
    return {
        emailConfirmSuccessText: state.messages.pageMessages.emailConfirmSuccessText,
        continueButton: state.messages.pageMessages.continueButton,
        emailNotConfirmText: state.messages.pageMessages.emailNotConfirmText,
        confirm: state.extra.confirm,
        authUser: state.auth.authUser,
        lang: state.language.lang,
        country: state.app.country,
    };
};
export default connect(mapStateToProps)(BasePage(EmailConfirm));
